// extracted by mini-css-extract-plugin
export var accordionBg = "Faq-module--accordionBg--L0dci";
export var accordionBtn = "Faq-module--accordionBtn--IwBs9";
export var accordionItem = "Faq-module--accordionItem--u1FME";
export var accordionSection = "Faq-module--accordionSection--Onb5F";
export var accordionTitle = "Faq-module--accordionTitle--doE3h";
export var accordionTop = "Faq-module--accordionTop--LGP3o";
export var collapsed = "Faq-module--collapsed--CCOHa";
export var darkHr = "Faq-module--darkHr--stGAj";
export var darkHr2 = "Faq-module--darkHr2--7J3s9";
export var desc = "Faq-module--desc--DIt8K";
export var faq = "Faq-module--faq--D1EzY";
export var heading = "Faq-module--heading--rzHd8";
export var healList = "Faq-module--healList--IWfj2";